import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ReactCountryFlag from 'react-country-flag';
import './language-switcher.scss';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        // Устанавливаем британский английский как язык по умолчанию
        if (!i18n.language) {
            i18n.changeLanguage('en-GB');
        }
    }, [i18n]);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setIsOpen(false); // Закрываем меню после выбора языка
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const languages = [
        { code: 'en-GB', name: 'English (UK)' },
        { code: 'ru', name: 'Русский' },
        { code: 'pl', name: 'Polski' },
        { code: 'de', name: 'Deutsch' },
        { code: 'fr', name: 'Français' }
    ];

    const getCountryCode = (code) => {
        // Используем вторую часть кода языка, если есть дефис
        return code.includes('-') ? code.split('-')[1] : code;
    };

    return (
        <div className="language-switcher">
            <button onClick={toggleDropdown} className="language-switcher__button">
                <ReactCountryFlag
                    countryCode={getCountryCode(i18n.language || 'en-GB').toUpperCase()}
                    svg
                    style={{ width: '42px', height: '42px' }}
                    alt="Current Language"
                />
            </button>
            {isOpen && (
                <div className="language-switcher__dropdown">
                    {languages.map(lang => (
                        <div key={lang.code} onClick={() => changeLanguage(lang.code)}>
                            <ReactCountryFlag
                                countryCode={getCountryCode(lang.code).toUpperCase()}
                                svg
                                style={{ width: '20px', height: '20px', marginRight: '8px' }}
                                alt={lang.name}
                            />
                            <span>{lang.name}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageSwitcher;
